import React, { useMemo } from 'react';
import {
  bool, string, arrayOf, shape, func,
} from 'prop-types';
import { useField } from 'react-final-form';
import Select from 'react-select';

import Layout from './Layout';

const SelectField = (props) => {
  const { input, meta } = useField(props.name, {
    validate: props.validate,
  });
  const error = meta.touched && (meta.error || meta.submitError);

  const selectStyles = {
    menu: (styles) => ({ ...styles, zIndex: 999 }),
    control: (styles, state) => ({
      ...styles,
      borderColor:
        error && !state.isFocused ? 'hsl(348, 100%, 61%)' : styles.borderColor,
    }),
  };

  const getValue = () => {
    if (!input.value) {
      return null;
    }
    // react-select wants value as an object shaped like {value: string, label: string}
    if (!props.isMulti) {
      return input.value.value
        ? input.value
        : props.options.find((option) => option.value === input.value);
    }
    return input.value.map((el) => (el.value ? el : props.options.find((option) => option.value === el)));
  };

  const onChange = (selection) => {
    if (!selection) {
      return input.onChange(selection);
    }
    const value = props.isMulti
      ? selection.map((el) => el.value)
      : selection.value;

    return input.onChange(value);
  };

  const options = useMemo(
    () => (props.allowEmpty
      ? [{ value: '', label: 'Seleziona' }, ...props.options]
      : props.options),
    [props.allowEmpty, props.options],
  );

  if (props.noLayout) {
    return (
      <Select
        {...props}
        value={getValue()}
        onChange={(selection) => onChange(selection)}
        onBlur={() => input.onBlur(input.value)}
        options={options}
        styles={selectStyles}
      />
    );
  }
  return (
    <Layout label={props.label} isHorizontal={props.isHorizontal}>
      <Select
        {...props}
        value={getValue()}
        onChange={(selection) => onChange(selection)}
        onBlur={() => input.onBlur(input.value)}
        options={options}
        styles={selectStyles}
      />
      {error && <p className="help is-danger">{error}</p>}
    </Layout>
  );
};
SelectField.displayName = 'SelectField';
SelectField.propTypes = {
  noLayout: bool,
  name: string.isRequired,
  isHorizontal: bool,
  label: string,
  options: arrayOf(
    shape({
      label: string,
      value: string,
    }),
  ).isRequired,
  isMulti: bool,
  validate: func,
  allowEmpty: bool,
};

export default SelectField;
